import {post,get} from '../../libs/ajax.js';

export default {
    // 产品KPI-获取筛选框下拉列表
    getSearchOptions:(data,options) => {
        if(data.plat_id=='1'){
            return post('/app_kpi_manage/oppo/get_search_list', data, options);
        }else if(data.plat_id=='3'){
            return post('/app_kpi_manage/vivo/get_search_list', data, options);
        }else if(data.plat_id=='7'){
            return post('/app_kpi_manage/mi/get_search_list', data, options);
        }
        return post('/app_kpi_manage/get_search_list', data, options);
    },
    // 产品KPI-获取列表
    getDataList:(data,options) => {
        if(data.plat_id=='1'){
            return post('/app_kpi_manage/oppo/get_list', data, options);
        }else if(data.plat_id=='3'){
            return post('/app_kpi_manage/vivo/get_list', data, options);
        }else if(data.plat_id=='7'){
            return post('/app_kpi_manage/mi/get_list', data, options);
        }
        return post('/app_kpi_manage/get_list', data, options);
    },
    // 产品KPI-获取产品kpi详情
    getAppDetail:(data,options) => {
        if(data.plat_id=='1'){
            return get('/app_kpi_manage/oppo/get_detail', data, options);
        }else if(data.plat_id=='3'){
            return get('/app_kpi_manage/vivo/get_detail', data, options);
        }else if(data.plat_id=='7'){
            return get('/app_kpi_manage/mi/get_detail', data, options);
        }
        return get('/app_kpi_manage/get_detail', data, options);
    },
    // 产品KPI-获取产品编辑信息
    getAppInfo:(data,options) => {
        if(data.plat_id=='1'){
            return get('/app_kpi_manage/oppo/get_edit_info', data, options);
        }else if(data.plat_id=='3'){
            return get('/app_kpi_manage/vivo/get_edit_info', data, options);
        }else if(data.plat_id=='7'){
            return get('/app_kpi_manage/mi/get_edit_info', data, options);
        }
        return get('/app_kpi_manage/get_edit_info', data, options);
    },
    // 产品KPI-编辑产品kpi
    editAppKpi(data,options){
        if(data.plat_id=='1'){
            return post('/app_kpi_manage/oppo/edit', data, options);
        }else if(data.plat_id=='3'){
            return post('/app_kpi_manage/vivo/edit', data, options);
        }else if(data.plat_id=='7'){
            return post('/app_kpi_manage/mi/edit', data, options);
        }
        return post('/app_kpi_manage/edit',data,options);
    },
    // 产品KPI-批量编辑产品kpi
    batchEditAppKpi(data,options){
        if(data.plat_id=='1'){
            return post('/app_kpi_manage/oppo/batch_edit', data, options);
        }else if(data.plat_id=='3'){
            return post('/app_kpi_manage/vivo/batch_edit', data, options);
        }else if(data.plat_id=='7'){
            return post('/app_kpi_manage/mi/batch_edit', data, options);
        }
        return post('/app_kpi_manage/batch_edit',data,options);
    },
    // 产品KPI-批量导入 前置检验
    checkBatchImport(data,options){
        if(data.plat_id=='1'){
            return post('/app_kpi_manage/oppo/check_batch_import', data, options);
        }else if(data.plat_id=='3'){
            return post('/app_kpi_manage/vivo/check_batch_import', data, options);
        }else if(data.plat_id=='7'){
            return post('/app_kpi_manage/mi/check_batch_import', data, options);
        }
        return post('/app_kpi_manage/check_batch_import',data,options);
    },
    // 产品KPI-批量导入
    batchImport(data,options){
        if(data.plat_id=='1'){
            return post('/app_kpi_manage/oppo/batch_import', data, options);
        }else if(data.plat_id=='3'){
            return post('/app_kpi_manage/vivo/batch_import', data, options);
        }else if(data.plat_id=='7'){
            return post('/app_kpi_manage/mi/batch_import', data, options);
        }
        return post('/app_kpi_manage/batch_import',data,options);
    },

    // 产品KPI-获取自定义字段
    getCustomField:(data,options) => {
        return get('/custom_field/get', data, options);
    },
    // 产品KPI-设置自定义字段
    setCustomField:(data,options) => {
        return post('/custom_field/edit', data, options);
    },
    // 产品KPI-获取筛选条件
    getCustomFilter:(data,options) => {
        return get('/custom_filter/get', data, options);
    },
    // 产品KPI-设置筛选条件
    setCustomFilter:(data,options) => {
        return post('/custom_filter/edit', data, options);
    },
}
